export const SET_CUSTOMER_DETAILS = 'set-customer-details';
export const SET_CUSTOMER_ORDER_DETAILS = 'set-customer-order-details';
